import React, { useState } from "react";
import styled from "styled-components";
import { api } from "../../helpers/utils";

export default function BlockUser() {
  const [username, setUsername] = useState("");
  const [message, setMessage] = useState("");
  const [response, setResponse] = useState("");

  const handleAction = async (type) => {
    if (!username) {
      setResponse("Username is required");
      return;
    }

    if (type === "block" && !message) {
      setResponse("Block reason is required");
      return;
    }

    try {
      const res = await api.post("https://api1.pepchat.in/block-user", {
        u_username: username,
        blockMessage: message,
        isBlock: type === "block",
      });

      setResponse(res.data?.message || "Success");
    } catch (err) {
      console.log("ERROR:", err);
      setResponse("Operation failed");
    }
  };

  return (
    <Wrapper>
      <FormCard>
        <Title>Block / Unblock User</Title>

        <Field>
          <Label>Username (u_username)</Label>
          <Input placeholder="Enter username" value={username} onChange={(e) => setUsername(e.target.value)} />
        </Field>

        <Field>
          <Label>Reason for blocking</Label>
          <Textarea
            placeholder="Required when blocking the user"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
        </Field>

        <ButtonRow>
          <BlockButton onClick={() => handleAction("block")}>Block User</BlockButton>
          <UnblockButton onClick={() => handleAction("unblock")}>Unblock User</UnblockButton>
        </ButtonRow>

        {response && <ResponseText>{response}</ResponseText>}
      </FormCard>
    </Wrapper>
  );
}

/* ------------ STYLES ------------ */

const Wrapper = styled.div`
  min-height: 100vh;
  background: #000000;
  color: #ffffff;
  padding: 60px 20px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
`;

const FormCard = styled.div`
  width: min(520px, 100%);
  background: #050505;
  border: 1px solid #303030;
  padding: 36px 30px 80px;
`;

const Title = styled.h2`
  font-size: 34px;
  font-weight: 700;
  margin-bottom: 28px;

  @media (max-width: 560px) {
    font-size: 26px;
  }
`;

const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 22px;
`;

const Label = styled.label`
  font-size: 14px;
  color: #bdbdbd;
`;

const Input = styled.input`
  width: 100%;
  padding: 16px 18px;
  border: 1px solid #303030;
  background: #000000;
  color: #ffffff;
  font-size: 16px;
  outline: none;

  &:focus {
    border-color: #ffffff;
  }
`;

const Textarea = styled.textarea`
  width: 100%;
  padding: 16px 18px;
  min-height: 120px;
  border: 1px solid #303030;
  background: #000000;
  color: #ffffff;
  font-size: 16px;
  outline: none;
  resize: none;

  &:focus {
    border-color: #ffffff;
  }
`;

const ButtonRow = styled.div`
  display: flex;
  gap: 18px;
  width: 100%;
  margin-top: 20px;

  @media (max-width: 560px) {
    flex-direction: column;
    position: sticky;
    bottom: 20px;
  }
`;

const BlockButton = styled.button`
  flex: 1;
  padding: 16px;
  background: #000000;
  color: #ffffff;
  border: 1px solid #ffffff;
  font-size: 18px;
  font-weight: 800;
  cursor: pointer;
  transition: 0.25s ease;

  &:hover {
    background: #ffffff;
    color: #000000;
  }
`;

const UnblockButton = styled.button`
  flex: 1;
  padding: 16px;
  background: #ffffff;
  color: #000000;
  border: 1px solid #ffffff;
  font-size: 18px;
  font-weight: 800;
  cursor: pointer;
  transition: 0.25s ease;

  &:hover {
    background: #000000;
    color: #ffffff;
  }
`;

const ResponseText = styled.div`
  margin-top: 18px;
  font-size: 15px;
  color: #ffffff;
  text-align: center;
`;
